import {httpClient} from "../../shared/shared-services/httpClient";
import {environment} from "@/environment";

const URL = `${environment.eventApiBaseUrl}event-definition`;
export default {
  fetchAllEventsDefinition(query) {
    const url = URL + query;
    return httpClient.get(url)
      .then(res => res.data.data)
      .catch(error => console.log(error));
  },
  storeEventDefinition(event) {
    return httpClient.post(URL, event)
      .then(res => res.data)
      .catch(error => console.log(error));
  },
  updateEventDefinition(event, id) {
    const url = URL + `/${id}?_method=PUT`;
    return httpClient.post(url, event)
      .then(res => res.data)
      .catch(error => console.log(error));
  },

  deleteEventDefinition(ids) {
    return httpClient.delete(`${URL}/${ids}`)
      .then(res => res.data)
      .catch(error => console.log(error));
  },
  fetchStatistics(id) {
    const url = URL + `/${id}/statistics`;
    return httpClient.get(url)
      .then(res => res.data.data)
      .catch(error => console.log(error));
  },
  exportEventDefinitionToExcel() {
    const url = URL + '/export';
    return httpClient.get(url, {responseType: 'arraybuffer'})
      .then(res => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'eventsDefinition.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch(error => console.log(error));
  },
};
